import React, { useState } from 'react';
import { MessageSquare, PhoneCall, Scale } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Contrôles de suivi d'appel réutilisables : cases "A décroché" / "Souhaite avocat"
 * + éditeur de commentaire inline. Purement présentationnel — le parent gère
 * la persistance via onToggle / onSaveComment.
 *
 * Props :
 *  - answered, wantsLawyer : booléens
 *  - comment : string
 *  - onToggle(field) : appelé avec 'answered' | 'wants_lawyer'
 *  - onSaveComment(text) : appelé avec le nouveau commentaire
 */
const CrmCallTracking = ({ answered, wantsLawyer, comment, onToggle, onSaveComment }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const handleSave = () => {
    onSaveComment(draft);
    setEditing(false);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-6">
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={!!answered}
            onChange={() => onToggle('answered')}
            className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <PhoneCall size={14} className="text-gray-500" />
          <span className="text-sm text-gray-700">A décroché</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={!!wantsLawyer}
            onChange={() => onToggle('wants_lawyer')}
            className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <Scale size={14} className="text-gray-500" />
          <span className="text-sm text-gray-700">Souhaite avocat</span>
        </label>
      </div>

      {editing ? (
        <div className="space-y-2">
          <textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Notes suite à l'appel..."
            className="w-full p-2 text-sm border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            rows={3}
            autoFocus
          />
          <div className="flex gap-2">
            <Button size="sm" onClick={handleSave}>
              Sauvegarder
            </Button>
            <Button variant="ghost" size="sm" onClick={() => setEditing(false)}>
              Annuler
            </Button>
          </div>
        </div>
      ) : (
        <div
          className="flex items-start gap-2 cursor-pointer group"
          onClick={() => {
            setEditing(true);
            setDraft(comment || '');
          }}
        >
          <MessageSquare size={14} className="text-gray-400 mt-0.5 flex-shrink-0" />
          {comment ? (
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{comment}</p>
          ) : (
            <p className="text-sm text-gray-400 italic group-hover:text-gray-600">
              Ajouter un commentaire...
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CrmCallTracking;
